var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('span',{staticClass:"zp-status",class:_vm.statusClass},[_vm._v(_vm._s(_vm.humanizedStatus))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }